import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import './CsvViewer.css'; 

interface CsvViewerProps {
  url: string;
}

const CsvViewer: React.FC<CsvViewerProps> = ({ url }) => {
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const limit = 20;

  const observer = useRef<IntersectionObserver | null>(null);
  const lastRowRef = useCallback(
    (node:any) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && data.length < totalRows) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, data.length, totalRows]
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(url, {
          params: { page, limit },
        });
        setData((prevData) => [...prevData, ...response.data.data]);
        setTotalRows(response.data.totalRows);
      } catch (err:any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, url]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <table>
        <thead>
          <tr>
            {data[0] &&
              Object.keys(data[0]).map((header, index) => (
                <th key={index}>{header}</th>
              ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.values(row).map((cell:any, cellIndex) => (
                <td key={cellIndex}>{cell}</td>
              ))}
            </tr>
          ))}
          <tr ref={lastRowRef} />
        </tbody>
      </table>
      {loading && <div>Loading...</div>}
    </>
  );
};

export default CsvViewer;
